export default __webpack_public_path__ + "static/media/head.dc10e9ac.svg";